import { render, staticRenderFns } from "./PlaylistsBySportsType.vue?vue&type=template&id=4376c057&scoped=true"
import script from "./PlaylistsBySportsType.vue?vue&type=script&lang=js"
export * from "./PlaylistsBySportsType.vue?vue&type=script&lang=js"
import style0 from "./PlaylistsBySportsType.vue?vue&type=style&index=0&id=4376c057&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4376c057",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})


/* vuetify-loader */
import installDirectives from "!../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
